import gql from "graphql-tag";

export const CREATE_DISCOUNT_CODE = gql`
  mutation AddDiscountCode($data: DiscountCodeDataInput) {
    addDiscountCode(data: $data) {
      id
    }
  }
`;

export const UPDATE_DISCOUNT_CODE = gql`
  mutation UpdateDiscountCode(
    $data: DiscountCodeDataInput
    $where: DiscountCodeWhereInput
  ) {
    updateDiscountCode(data: $data, where: $where) {
      id
    }
  }
`;

export const DELETE_DISCOUNT_CODE = gql`
  mutation DeleteDiscountCode($where: DiscountCodeWhereInput) {
    deleteDiscountCode(where: $where) {
      id
    }
  }
`;

const discountCodes = {
  CREATE_DISCOUNT_CODE,
  UPDATE_DISCOUNT_CODE,
  DELETE_DISCOUNT_CODE,
};

export default discountCodes;
